export default __webpack_public_path__ + "static/media/logo-text.2f76a807.png";